import { render, staticRenderFns } from "./CustomerDebtReport.vue?vue&type=template&id=9bc57512&scoped=true"
import script from "./CustomerDebtReport.vue?vue&type=script&lang=js"
export * from "./CustomerDebtReport.vue?vue&type=script&lang=js"
import style0 from "./CustomerDebtReport.vue?vue&type=style&index=0&id=9bc57512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc57512",
  null
  
)

export default component.exports